import HistoryChartPeriodSelect from '../../../Layout/Chart/HistoryChartPeriodSelect';
import Chart from './HydrationHistoryChart';
import { useTranslator } from '@front-activerse/common-components';
import { Row, Col } from 'reactstrap';

const HydrationHistory = ({
  historyLength,
  loading,
  dateFrom,
  dateTo,
  unit,
  days,
  defaultDailyGoal,
  setHistoryLength,
}) => {
  const { t } = useTranslator();

  const handleHistoryLengthChange = (event) => {
    const value = parseInt(event.target.value, 10);
    setHistoryLength(value);
  };

  return (
    <div className="history-container">
      <h3 className="title-medium semi-bold mb-m">{t('hydration.history.headline')}</h3>
      <div className="hydration-box">
        <Row>
          <Col xl={{ size: 6, offset: 3 }}>
            <HistoryChartPeriodSelect value={historyLength} onChange={handleHistoryLengthChange} />

            <Chart
              loading={loading}
              dateFrom={dateFrom}
              dateTo={dateTo}
              unit={unit}
              days={days}
              defaultDailyGoal={defaultDailyGoal}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default HydrationHistory;
